import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface BiPageData {
  title: string;
  url: string;
  subPath: string;
}

@Injectable({ providedIn: "root" })
export class BiPageDataService {
  private _data$ = new BehaviorSubject<BiPageData | null>(null);
  data$ = this._data$.asObservable();

  setData(data: BiPageData) {
    this._data$.next(data);
  }
}
